import clsx from 'clsx'
import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import PropTypes from 'prop-types'
import Typo from 'constants/typography'
import { segmentFeaturedCellClicked } from 'components/home/home-page-segment/homePageSegment'
import styles from './content-sticky-navigations.scss'
import homePageDuck from '../../duck'
import scrollToContentStickyNavigations from './utility'

const ContentStickyNavigations = ({
  isPhone,
  topNavigations,
  categoryProducts,
  selectedTopNavigation,
  updateSelectedTopNavigation,
}) => {
  const isFetching =
    categoryProducts?.didInvalidate || categoryProducts?.isFetching

  const handleClickNavigation = (navigation, index) => {
    segmentFeaturedCellClicked({
      ref_id: navigation?.id,
      cta_type: navigation?.attributes?.sub_type,
      position: index + 1,
      position_type: navigation?.attributes?.navigation_type,
    })
    updateSelectedTopNavigation(navigation)

    scrollToContentStickyNavigations()
  }

  return (
    <React.Fragment>
      <div id="content-sticky-navigations-scroll-point" />
      {isPhone && (
        <div className={clsx('content-sticky-navigations')}>
          <style jsx>{styles}</style>
          {topNavigations?.map((navigation, index) => {
            const isSelected = navigation?.id === selectedTopNavigation?.id

            return (
              <div
                tabIndex="0"
                role="button"
                key={navigation?.id}
                className={clsx(
                  'content-sticky-navigations__button',
                  {
                    'selected-button': isSelected,
                    'is-disabled': isFetching,
                  },
                  isPhone ? Typo.body2 : Typo.body1,
                )}
                onClick={() => handleClickNavigation(navigation, index)}
                onKeyUp={() => handleClickNavigation(navigation, index)}
              >
                {navigation.attributes.title}
              </div>
            )
          })}
        </div>
      )}
    </React.Fragment>
  )
}

ContentStickyNavigations.propTypes = {
  categoryProducts: PropTypes.shape({
    didInvalidate: PropTypes.bool,
    isFetching: PropTypes.bool,
  }),
  isPhone: PropTypes.bool.isRequired,
  selectedTopNavigation: PropTypes.shape({
    type: PropTypes.string,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    title: PropTypes.string,
  }),
  topNavigations: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string,
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      title: PropTypes.string,
    }),
  ),
  updateSelectedTopNavigation: PropTypes.func.isRequired,
}

ContentStickyNavigations.defaultProps = {
  topNavigations: [],
  categoryProducts: {},
  selectedTopNavigation: null,
}

export default connect(
  (state) => ({
    isPhone: state.device.isPhone,
    categoryProducts: state.products,
    topNavigations: state.homePage.topNavigations,
    selectedTopNavigation: state.homePage.selectedTopNavigation,
  }),
  (dispatch) =>
    bindActionCreators(
      {
        updateSelectedTopNavigation:
          homePageDuck.creators.updateSelectedTopNavigation,
      },
      dispatch,
    ),
)(ContentStickyNavigations)
